import React from 'react';
import {TextField} from "@mui/material";

interface Props {
    placeholder?: string,
    field: string,
    handleChange: (val: any) => void,
    width?: string,
    values: any,
    type?: string,
    formik: any,
    size?:"small" | "medium" | undefined

}

const CustomSearch: React.FC<Props> = ({
                                           placeholder,
                                           field,
                                           handleChange,
                                           width = "200px",
                                           values,
                                           type = "text",
                                           formik,
                                           size
                                       }) => {
    //console.log(width,'wid')
    return (
        <TextField
            id={field}
            name={field}
            value={values[`${field}`]}
            onChange={handleChange}
            variant="outlined"
            placeholder={placeholder}
            type={type}
            size={size&&size}
            sx={{
                width: width
            }}
            error={formik.touched[`${field}`] && Boolean(formik.errors[`${field}`])}
            helperText={formik.touched[`${field}`] && formik.errors[`${field}`]}

        />
    );
};

export default CustomSearch;